/*
 * @Author: caiqin.xie
 * @since: 2023-06-28 17:12:46
 * @lastTime: 2023-11-23 16:19:47
 * @LastEditors: caiqin.xie
 * @message: FAQ
 * @url: www.picoxr.com/cn/support/faq
 */
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Input, Empty } from '@arco-design/web-react';
import { IconSearch } from '@arco-design/web-react/icon';
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import QuickSearch from "./components/QuickSearch"
import FAQList from "./components/FaqList";
import styles from "./index.module.scss";
import { useDevice } from "@/hooks";
import request from '@/common/request';
import { DOMAIN_API, COUNTRY_HREFLANG, COUNTRY_LIST, CONTENTTYPEID } from '@/common/const'
const _ = require('lodash')

interface IList {
  briefIntroduction: string; // 简介
  cover?: string; // 封面
  detail: string; // 详情
  id: string;
  labelName: string; // 标签名称
  title: string; // 标题
  [propName:string]:any
}
const FrequentlyAskedQuestion = (props: any) => {
  const { ctry, words, data: {labels, contents }, data } = props.data
  const [contentList, setContentList] = useState<IList[]>(contents?.records ||[]) // faq列表
  const [pageNum, setPageNum] = useState<number>(1) // 当前页码
  const [pages, setPages] = useState<number>(contents?.pages * 1 || 1) // 总页码
  const [total, setTotal] = useState<number>(contents?.total * 1 || 0) // 总条数
  const device = useDevice()
  // const [currentLabelName, setCurrentLabelName] = useState<string>(labels[0].labelName);
  const [currentLabelName, setCurrentLabelName] = useState<string>(); // 当前标签名称
  const [keyword,setKeyword] = useState<string>() // 搜索关键字

  // 获取列表
  const getList = (pageNum: number, labelName?: string) => {
    pageNum===1 && setContentList([])
    request.post(`${DOMAIN_API}/o/official/content/getContentPage`, {
      stationCode: ctry,
      contentTypeId: CONTENTTYPEID,
      keyword,
      labelName: labelName? labelName:currentLabelName,//标签名称
      page: pageNum,
      rows: 10
    })
      .then(res => {
        const{total, pages, current, records } = res.data
        setContentList((contentList:IList[]) => _.uniqBy([...contentList, ...records], 'id'))
        setTotal(total * 1)
        setPages(pages * 1)
        setPageNum(current * 1)
    })
    .catch(err => {
      console.log(err)
    })
  }
  // 分页改变
  const pageChange = (pageNum:number) => {
    setPageNum(pageNum)
    getList(pageNum, currentLabelName)
  }

  // 生成hreflang
  const renderHrefLang = () => {
    return (
      COUNTRY_LIST.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/support/faq`} />
      ))
    )
  }
  return (
    <div>
      <Helmet>
        <title>{words.support_faq_seo_title}</title>
        <meta name="description" content={words.support_faq_seo_description} />
        <meta name="keywords" content={words.support_faq_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/support/faq`} />
        {renderHrefLang()}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['question-wrap']}>
        <div className={styles['question-content-wrap']}>
          <h1>
            {words?.support_faq_title}
            {/* FAQs */}
          </h1>

          <div className={styles["question-search"]}>
            <Input
              size="large"
              allowClear
              value={keyword}
              onChange={(value:string) => setKeyword(value)}
              onPressEnter={() => getList(1, currentLabelName)}
              prefix={<IconSearch onClick={ ()=>getList(1,currentLabelName)} />}
              placeholder={words.support_faq_search}
            />
            {/* Search Support */}
          </div>

          {/* 快速搜索 */}
          <QuickSearch
            ctry={ctry}
            words={words}
            quickSearchList={labels}
            device={device}
            currentLabelName={currentLabelName}
            setCurrentLabelName={setCurrentLabelName}
            getList={(labelName:string)=>getList(1,labelName)}
          />

          {/* 列表数据 */}
          {contents.records?.length > 0 && (
            <>
              <FAQList ctry={ctry} words={words} questionList={contentList} />
              {pages > pageNum && <button className={styles["more-btn"]} onClick={() => { pageChange(pageNum + 1) }}>
                {words?.common_load_more}
                {/* Load More */}
              </button>}
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

function getInit (ctry: string) {
  return new Promise((resolve, reject) => {
    request.post(`${DOMAIN_API}/o/official/getLabelContentGather`, {
      page: 1,
      rows: 10,
      stationCode: ctry,
      contentTypeId: CONTENTTYPEID
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

FrequentlyAskedQuestion.getInitialProps = (ctry:string) => {
  return getInit(ctry)
};
export default FrequentlyAskedQuestion;
